import { useState, useEffect } from 'react';
import dayjs from 'dayjs';

function Clock() {
  const [time, setTime] = useState(dayjs());

  useEffect(() => {
    // Función que actualiza el estado de `time` cada segundo
    const interval = setInterval(() => {
      setTime(dayjs());
    }, 1000);

    // Limpiar el intervalo al desmontar el componente
    return () => clearInterval(interval);
  }, []);

  return (
    <div className='clock'>
      <p>{time.format('HH:mm:ss')}</p>
    </div>
  );
}

export default Clock;